import React from 'react';
import {
  exhibitionGoogleCalendarUrl,
  exhibitionGoogleMapsUrl,
} from '../exhibitionsDisplay';

/**
 * Secondary actions on exhibition cards — directions, calendar, external event page.
 */
export default function ExhibitionShowActions({ row, brandName, compact = false }) {
  const mapsUrl = exhibitionGoogleMapsUrl(row);
  const calendarUrl = exhibitionGoogleCalendarUrl(row, { brandName });
  const externalUrl = String(row?.external_url || '').trim();

  if (!mapsUrl && !calendarUrl && !externalUrl) return null;

  const className = `exhibition-show-actions${compact ? ' exhibition-show-actions--compact' : ''}`;

  return (
    <div className={className}>
      {mapsUrl ? (
        <a
          href={mapsUrl}
          className="exhibition-show-actions__btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get directions
        </a>
      ) : null}
      {calendarUrl ? (
        <a
          href={calendarUrl}
          className="exhibition-show-actions__btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Add to calendar
        </a>
      ) : null}
      {externalUrl ? (
        <a
          href={externalUrl}
          className="exhibition-show-actions__btn exhibition-show-actions__btn--accent"
          target="_blank"
          rel="noopener noreferrer"
        >
          Event page
        </a>
      ) : null}
    </div>
  );
}
